import { ISVGIconProps } from '@cian/ui-kit-design-tokens/icons';
import React from 'react';

export enum EScrollUpButtonType {
  Filters = 'filters',
  Up = 'up',
}

export type ScrollUpButtonProps = { onClick: () => void; icon: React.FC<ISVGIconProps>; testId?: string };
